/** Type de client — miroir `facturx_client_profile_gaps`. */
import type { ClientDraft, ClientKind } from "../features/clients/types";

export type { ClientKind };

export function clientKindOf(d: ClientDraft): ClientKind {
  return d.kind;
}

export function applyClientKind(draft: ClientDraft, kind: ClientKind): ClientDraft {
  if (kind === "particulier") {
    return {
      ...draft,
      kind,
      siret: "",
      siren: "",
      vat_number: "",
      vat_valid: false,
      tax_exempt: false,
    };
  }
  if (kind === "micro") {
    return { ...draft, kind, vat_number: "", vat_valid: false, tax_exempt: true };
  }
  return { ...draft, kind, tax_exempt: false };
}

export function clientProfileGaps(d: ClientDraft): string[] {
  const missing: string[] = [];
  if (!d.name.trim()) missing.push("nom du client");
  if (!d.address_line.trim() || !d.postal_code.trim() || !d.city.trim()) {
    missing.push("adresse complète du client (rue, code postal, ville)");
  }
  const kind = clientKindOf(d);
  const siret = d.siret.replace(/\D/g, "");
  const siren = d.siren.replace(/\D/g, "");
  if (kind === "micro") {
    if (siret.length !== 14 && siren.length !== 9) missing.push("SIRET (14) ou SIREN (9) du client micro");
  } else if (kind === "societe") {
    if (siret.length !== 14) missing.push("SIRET (14 chiffres) du client");
    if (siren.length !== 9) missing.push("SIREN (9 chiffres) du client");
    if (!d.vat_number.trim()) missing.push("n° de TVA du client (ou type Micro)");
  }
  return missing;
}
